import { SEOHead } from "@/components/seo/SEOHead";
import { useRoOnlyGuard } from '@/hooks/useRoOnlyGuard';

export default function Accesibilitate() {
  const __roBlocked = useRoOnlyGuard();
  return (
    <>
      <SEOHead
        title="Declarație de Accesibilitate - ROAutoMarket"
        description="Angajamentul nostru pentru o platformă accesibilă conform WCAG 2.1 AA."
        canonicalPath="/accesibilitate"
      />
      <div className="container mx-auto px-4 py-10 max-w-4xl">
        <div className="surface-dark band-bleed -mt-10 mb-8 py-6"><h1 className="text-3xl md:text-4xl font-bold">Declarație de Accesibilitate</h1></div>
        <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6">
          <p className="text-sm text-muted-foreground">Ultima actualizare: {new Date().toLocaleDateString("ro-RO")}</p>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Angajamentul nostru</h2>
            <p>
              RO Auto Market depune eforturi continue pentru ca platforma <strong>roautomarket.ro</strong> să fie accesibilă
              tuturor utilizatorilor, inclusiv persoanelor cu dizabilități, conform standardului
              <strong> WCAG 2.1 nivel AA</strong>, Directivei (UE) 2019/882 și Legii 232/2022.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Măsuri implementate</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Contrast minim 4.5:1 pentru textul de bază;</li>
              <li>Text alternativ descriptiv pentru imagini;</li>
              <li>Etichete vizibile pentru toate formularele;</li>
              <li>Navigare completă cu tastatura (Tab, Enter, Esc);</li>
              <li>Ierarhie corectă a titlurilor (H1, H2, H3);</li>
              <li>Componente accesibile (Radix UI / shadcn) cu suport ARIA;</li>
              <li>Design responsiv pentru ecrane mici și suport pentru zoom 200%;</li>
              <li>Indicatori vizibili pentru focus.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Limitări cunoscute</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Unele anunțuri pot avea fotografii fără text alternativ descriptiv (text generat automat din titlu).</li>
              <li>Conținut video încorporat din surse externe poate să nu aibă subtitrări în toate cazurile.</li>
              <li>Anumite hărți interactive pot fi parțial accesibile cititoarelor de ecran.</li>
            </ul>
            <p>Lucrăm continuu pentru a remedia aceste aspecte.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Cum semnalezi o problemă</h2>
            <p>
              Dacă întâmpini o barieră de accesibilitate, te rugăm să ne contactezi:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Email: <a href="mailto:contact@roautomarket.ro" className="text-primary hover:underline">contact@roautomarket.ro</a></li>
              <li>WhatsApp: <a href="https://wa.me/40732963134" className="text-primary hover:underline">+40 732 963 134</a></li>
            </ul>
            <p>Vom răspunde în maxim 10 zile lucrătoare și vom încerca să oferim conținutul într-un format alternativ.</p>
          </section>
        </div>
      </div>
    </>
  );
}
